<template>
    <router-link
      :to="linkToPage"
      class="group relative grid grid-cols-[1fr_auto] items-center px-5 py-4 transition"
      :class="iconStatus.text"
    >
      <!-- Colonne gauche : titre, sous-titre, badge -->
      <div class="flex flex-col gap-2">
        <p class="details-outil">
          <strong class="type text-primary uppercase font-extrabold tracking-wide" v-if="outil.type_outil">
            {{ outil.type_outil.nom }}
          </strong>
          <span class="block text-secondary">
            <b class="marque">{{ outil.marque }}</b>
            <span class="text-gray-400"> - </span>
            <span class="modele">{{ outil.modele }}</span>
          </span>
        </p>

        <!-- Badge "Contrôlé le ..." -->
        <div class="tooltip"
             :class="[
               iconStatus.text === 'valid' ? 'bg-success' :
               iconStatus.text === 'warning' ? 'bg-warning' :
               iconStatus.text === 'error' ? 'bg-alert' : '',
               'inline-flex items-center gap-2 rounded-r-full px-3 py-1 text-sm font-semibold text-white -ml-4 w-fit'
             ]">
          <i class="inline-block h-6 w-6 mask mask-tools bg-white mr-2"></i>
          <span>Contrôlé le <strong>{{ outil.date_last_controle | dateFormat }}</strong></span>
        </div>
      </div>

      <!-- Colonne droite : chevron -->
      <div class="justify-self-end self-center">
        <span class="h-10 w-10 rounded-full grid place-content-center bg-[#0C2A5C] text-white
                     hover:opacity-90 active:scale-95 transition">
          <i class="inline-block mask mask-arrow-left rotate-180 w-8 h-8 bg-white"></i>
        </span>
      </div>
    </router-link>
  </template>

<script>
    export default {
        data() {
            return {
                isActive: true
            }
        },
        props: {
            outil: {},
        },
        computed: {
            linkToPage: function () {
                return 'outil/' + this.outil.id;
            },

            iconStatus: function () {
                let diff = moment().diff(moment(this.outil.date_last_controle), 'month', true);
                if (diff >= 12) {
                    return {
                        icon: 'icon-error',
                        text: 'error'
                    }
                } else if (diff < 12 && diff >= 11) {
                    return {
                        icon: 'icon-valid',
                        text: 'warning'
                    }
                } else {
                    return {
                        icon: 'icon-valid',
                        text: 'valid'
                    }
                }
            }
        },
        methods: {

        }
    }
</script>




// WEBPACK FOOTER //
// OutilItem.vue?4e5bff74